var _rect, _path, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopDownSquareIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#5CB335",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4911 34.9045C30.2061 34.9045 29.9211 34.7994 29.6961 34.5744L25.1961 30.0744C24.7611 29.6394 24.7611 28.9195 25.1961 28.4845C25.6311 28.0495 26.3511 28.0495 26.7861 28.4845L30.4911 32.1895L34.1961 28.4845C34.6311 28.0495 35.3511 28.0495 35.7861 28.4845C36.2211 28.9195 36.2211 29.6394 35.7861 30.0744L31.2861 34.5744C31.0611 34.7994 30.7761 34.9045 30.4911 34.9045Z",
    fill: "#5AAD46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4912 34.9043C29.8762 34.9043 29.3662 34.3943 29.3662 33.7793V21.7793C29.3662 21.1643 29.8762 20.6543 30.4912 20.6543C31.1062 20.6543 31.6162 21.1643 31.6162 21.7793V33.7793C31.6162 34.4093 31.1062 34.9043 30.4912 34.9043Z",
    fill: "#5AAD46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4911 39.3599C27.3261 39.3599 24.1461 38.8499 21.1311 37.8449C20.5461 37.6499 20.2311 37.0049 20.4261 36.4199C20.6211 35.8349 21.2511 35.5049 21.8511 35.7149C27.4311 37.5749 33.5661 37.5749 39.1461 35.7149C39.7311 35.5199 40.3761 35.8349 40.5711 36.4199C40.7661 37.0049 40.4511 37.6499 39.8661 37.8449C36.8361 38.8649 33.6561 39.3599 30.4911 39.3599Z",
    fill: "#5AAD46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6443,
    y: 15.1475,
    width: 29.7085,
    height: 29.7197,
    rx: 4,
    stroke: "#5AAD46",
    strokeWidth: 2.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopDownSquareIcon);
export default __webpack_public_path__ + "static/media/top-down-square-icon.3ee5aa69d8de12294801ddcbbbc77652.svg";
export { ForwardRef as ReactComponent };